module.exports = __webpack_public_path__ + "static/media/the-right-information-at-the-right-time-03@3x.07e606fb.png";